/**
 * preflight 专用入口：
 *   - 仅 import initPreflight + 立即调用
 *   - esbuild treeshake 后 < 2 KB（含 minify）
 *   - 编译为 `js/bootstrap-preflight.js`（IIFE），由 index.html `<head>` 同步加载，避免 FOUC
 *   - 勿用 `type="module"`：模块脚本 defer，会破坏首屏主题/背景预设
 */

import { initPreflight } from './preflight';

initPreflight();

if (typeof window !== 'undefined') {
  try {
    (window as unknown as { initPreflight: typeof initPreflight }).initPreflight = initPreflight;
  } catch {
    /* noop */
  }
}
